import FastAverageColor from 'fast-average-color/dist/index';
import anime from 'animejs';
import './projects-section.scss';
import movingImage from '../../moving-image';
import { areTransitionsSmooth } from '../../helpers';
import toDataUrl from '../../to-data-url';
import projectTransition from '../../project-transition';

const MAX_BG_BRIGHTNESS = 0.6;

const averageColor = new FastAverageColor();

const bg = document.createElement('div');
bg.classList.add('bg-color');
document.body.appendChild(bg);
anime.set(bg, { opacity: 0 });

let fullscreenObserver;
let hasRevealed = false;

function observeFullscreen(fullscreenImage, projectsList) {
  const src = fullscreenImage.dataset.fullscreenImage;
  if (fullscreenObserver) {
    fullscreenObserver.disconnect();
  }
  hasRevealed = movingImage.isAnimating();
  fullscreenObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      switch (entry.target) {
        case fullscreenImage:
          fullscreenImage.dataset.isIntersecting = entry.isIntersecting ? 'true' : 'false';
          if (entry.isIntersecting) {
            toDataUrl(src).then((b64) => {
              if (!document.body.contains(fullscreenImage) || fullscreenImage.dataset.isIntersecting === 'false') return;
              movingImage.setImage(b64);
              if (!hasRevealed && !movingImage.isAnimating()) {
                hasRevealed = true;
                movingImage.revealFullscreen();
              } else if (!movingImage.isAnimating()) {
                movingImage.instantFullscreen();
              }
            });
          } else {
            movingImage.reset();
          }
          break;
        case projectsList:
          movingImage.reset();
          break;
        default:
          //
      }
    });
  });
  fullscreenObserver.observe(projectsList);
  fullscreenObserver.observe(fullscreenImage);
}

function hoverEffect(links) {
  const effectObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = new Image();
        const el = entry.target;
        img.addEventListener('load', () => {
          const color = averageColor.getColor(img);
          const [r, g, b] = color.value;
          const avg = (r + g + b) / 3;
          const f = Math.min(MAX_BG_BRIGHTNESS * 256 / avg, 1);
          const resColor = `rgb(${r * f},${g * f},${b * f})`;
          const enter = () => {
            movingImage.setImage(img.src);
            movingImage.reveal();
            anime.remove(bg);
            anime({
              targets: bg,
              backgroundColor: resColor,
              opacity: 1,
              duration: 300,
              easing: 'linear',
            });
          };
          const leave = () => {
            movingImage.unreveal();
            anime.remove(bg);
            anime({
              targets: bg,
              opacity: 0,
              duration: 300,
              easing: 'linear',
            });
          };
          if (!window.isMobile.any) {
            el.addEventListener('mouseenter', enter);
            el.addEventListener('mouseleave', leave);
            el.addEventListener('mousemove', (e) => {
              movingImage.setPosition(e.x, e.y);
            });
          }
        });
        img.src = el.dataset.preview;
        effectObserver.unobserve(el);
      }
    });
  });
  links.forEach((link) => {
    if (!window.isMobile.any) {
      effectObserver.observe(link);
    }
    if (areTransitionsSmooth() && link.tagName === 'A') {
      link.addEventListener('click', (e) => {
        if (e.shiftKey || e.ctrlKey || e.metaKey) return;
        e.preventDefault();
        projectTransition.disableScroll();
        anime.remove(bg);
        anime({
          targets: bg,
          opacity: 0,
          duration: 500,
          easing: 'linear',
        });
      });
    }
  });
}

export default function (container) {
  const links = container.querySelectorAll('[data-project-link]');
  const fullscreenImage = container.querySelector('[data-fullscreen-image]');
  const projectsList = container.querySelector('[data-projects-list]');

  if (links.length > 0) {
    hoverEffect(links);
  }

  if (fullscreenImage) {
    observeFullscreen(fullscreenImage, projectsList);
  }
}
